import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BedSingle = t0 => {
  const $ = _c(10);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M4 4.5V12H21V4.5C21 3.67157 20.3284 3 19.5 3H19.3H5.7H5.5C4.67157 3 4 3.67157 4 4.5Z" />;
    t2 = <path d="M2 13.3333V20H23V13.3333C23 12.597 22.403 12 21.6667 12H20.9H4.1H3.33333C2.59695 12 2 12.597 2 13.3333Z" />;
    t3 = <path d="M2 17H23" />;
    t4 = <path d="M9 8.66667V12H16V8.66667C16 8.29848 15.7015 8 15.3333 8H15.3H9.7H9.66667C9.29848 8 9 8.29848 9 8.66667Z" />;
    t5 = <path d="M2 22.5V20H5V22.5V22.7C5 22.8657 4.86569 23 4.7 23H2.3C2.13431 23 2 22.8657 2 22.7V22.5Z" />;
    t6 = <path d="M20 22.5V20H23V22.5V22.7C23 22.8657 22.8657 23 22.7 23H20.3C20.1343 23 20 22.8657 20 22.7V22.5Z" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props) {
    t7 = <IconWrapper {...props} variant="outline" viewBox="0 0 25 25">{t1}{t2}{t3}{t4}{t5}{t6}</IconWrapper>;
    $[8] = props;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export { BedSingle };